import { getColor } from '../../hooks';
import React from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledFooter = styled.footer.withConfig({
  displayName: "layoutFooter__StyledFooter",
  componentId: "sc-17r89ig-0"
})(["background:", ";border-top:1px solid ", ";padding:16px 24px;text-align:center;color:rgba(0,0,0,0.45);@media (max-width:768px){padding:12px 16px;font-size:14px;}"], getColor('fillBgWhite'), getColor('fillBgWhite'));
export var LayoutFooter = function LayoutFooter(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(StyledFooter, {
    children: children
  });
};
LayoutFooter.displayName = 'LayoutFooter';